module.exports = __webpack_public_path__ + "static/media/sx.86cf183a.svg";